'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstHeaderButton = function (_VstComponent) {
  _inherits(VstHeaderButton, _VstComponent);

  function VstHeaderButton() {
    _classCallCheck(this, VstHeaderButton);

    return _possibleConstructorReturn(this, (VstHeaderButton.__proto__ || Object.getPrototypeOf(VstHeaderButton)).apply(this, arguments));
  }

  _createClass(VstHeaderButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'li',
        { className: 'vst-header-button' },
        _react2.default.createElement(
          'button',
          _extends({}, this.props, { className: 'vst-no-button little-head-button' }),
          this.props.children
        )
      );
    }
  }]);

  return VstHeaderButton;
}(_VstComponent3.default);

exports.default = VstHeaderButton;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstHeaderButton.js
 **/